export default "__VITE_ASSET__CU85TbnZ__"